import { Button, SvgIcon } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../assets/styles/themes/tokens';
import getMuiIcon from '../../utils/getMuiIcon';
import useScreenSize from '../../utils/useScreenSize';

interface MyCollectionsAddButtonProps {
	openCollectionFormModal: () => void;
}

const MyCollectionsAddButton: React.FC<MyCollectionsAddButtonProps> = ({
	openCollectionFormModal,
}) => {
	const { t } = useTranslation();
	const { isXsScreen } = useScreenSize();

	return (
		<Button
			variant="contained"
			color="primary"
			size={isXsScreen ? 'small' : 'large'}
			sx={{ padding: `${spaces.xs} ${spaces.lg}` }}
			onClick={openCollectionFormModal}
			type="button"
			aria-label={t('Add Collection')}
			startIcon={
				<SvgIcon
					component={getMuiIcon('addCollection')}
					viewBox="0 0 20 20"
					sx={{
						stroke: palette.primary.contrast,
						'& path': {
							fill: palette.primary.contrast,
						},
					}}
					aria-hidden="true"
				/>
			}
		>
			{t('Add Collection')}
		</Button>
	);
};

export default MyCollectionsAddButton;
